import React, { useState, useEffect } from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../Layout/GRISidebar";
import styles from "../../../styles/gri/general.module.css";
import { Box, Button, Alert, Snackbar } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, get } from "../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import SectionHeading from "../GRI300/GRI308/SectionHeading";
import CustomTextField from "../GRI300/GRI308/CustomTextField";
import ReviewBox from "../../../Components/Common/ReviewBox";
import { griReview, reviewBRSR, reviewGRI } from "../../../utils/companyId";
import { currentYear } from "../../../utils/generateYearRanges";

const GRI418 = ({hide}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);

  const [errors, setErrors] = useState({});
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [formData, setFormData] = useState({
    complaintsReceived: { percentage: "", remark: "" },
    regulatoryBodies: { percentage: "", remark: "" },
    customerDataIdentified: { percentage: "", remark: "" },
    noPrivacyComplaints: { percentage: "", remark: "" },
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/gri/get?type=GRI400&Id=${id}`);
        if (response?.data?.data?.year < currentYear - 1) setDisabled(true);
        const data = response.data.data.GRI400?.customerPrivacy || {};
        setFormData({
          complaintsReceived: {
            percentage: data.complaintsReceived?.percentage || "",
            remark: data.complaintsReceived?.remark || "",
          },
          regulatoryBodies: {
            percentage: data.regulatoryBodies?.percentage || "",
            remark: data.regulatoryBodies?.remark || "",
          },
          customerDataIdentified: {
            percentage: data.customerDataIdentified?.percentage || "",
            remark: data.customerDataIdentified?.remark || "",
          },
          noPrivacyComplaints: {
            percentage: data.noPrivacyComplaints?.percentage || "",
            remark: data.noPrivacyComplaints?.remark || "",
          },
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const handleStorage = () => {
      setGriReview(JSON.parse(localStorage.getItem("griReview")));
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  const handleNestedInputChange = (section, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));

    // Construct the correct error key
    const errorKey = `${section}.${field}`;

    // Remove error for the specific field if the value is valid
    setErrors((prev) => {
      if (value.trim()) {
        const { [errorKey]: removedError, ...rest } = prev; // Remove the specific error key
        return rest;
      }
      return prev;
    });
  };

  const validateForm = () => {
    let newErrors = {};
    let formIsValid = true;

    // List of fields to validate
    const fieldsToValidate = [
      "complaintsReceived",
      "regulatoryBodies",
      "customerDataIdentified",
      "noPrivacyComplaints",
    ];

    // Loop through each field and apply validation
    fieldsToValidate.forEach((field) => {
      const percentage = formData[field].percentage;
      const remark = formData[field].remark;

      // if (!percentage) {
      //   newErrors[`${field}.percentage`] = "This field is required";
      //   formIsValid = false;
      // } else
      if (isNaN(percentage)) {
        newErrors[`${field}.percentage`] = "Please enter a valid numeric value";
        formIsValid = false;
      } else if (percentage < 0) {
        newErrors[`${field}.percentage`] = "Please enter a valid numeric value";
        formIsValid = false;
      }

      // if (!remark) {
      //   newErrors[`${field}.remark`] = "This field is required";
      //   formIsValid = false;
      // }
    });

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      if (!validateForm()) return; // Validate form before submission

      console.log("Form Data Submitted:", formData);

      const payload = {
        type: "GRI400",
        submitted418: true,
        customerPrivacy: {
          ...formData,
        },
      };

      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        const response = await put(`/gri/update?Id=${id}`, payload);
        // const response1 = await put(`gri/grilist/update?id=${id}`, {status:"Completed"});
        setSnackOpen({
          open: true, 
          message: response.data.message,
          severity: "success",
        });
        const res = await get(
          `/gri/get/status?id=${id}`
        );
        if(res?.data?.griSubmitted===false)
          navigate('/gri');
        else
        setTimeout(() => {
          // navigate("");
          navigate(`/gri/review/${id}`);
        }, 2000);
      } catch (error) {
        console.error("Error updating data:", error);
        setSnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/review/${id}`);
    }
  };

  const renderContent = ({hide}) => (
     <>
      <p className={styles.section_heading} style={{ marginBottom: hide ? "-1rem" : "0" }}>418 : Customer Privacy</p>
      <p className={styles.main_heading} style={{ marginBottom: hide ? "-1rem" : "0" }}>
        418-1 : Substantiated complaints concerning breaches of customer privacy
        and losses of customer data
      </p>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {/* Section A */}

        <Box>
          <SectionHeading text="a. How many substantiated complaints concerning breaches of customer privacy were received? Please categorize them as follows:" />
          <Box
            sx={{
              display: "flex",
              width: "100%",
              gap: "10px",
              alignItems: "center",
            }}
          ></Box>

          <Box sx={{ marginLeft: "1rem", marginTop: "-1rem" }}>
            <SectionHeading text="i. Complaints received from external parties and substantiated by the organization." />
            <Box
              sx={{
                display: "flex",
                width: "100%",
                gap: "10px",
                alignItems: "center",
              }}
            >
              <Box sx={{ width: "15%" }}>
                <CustomTextField
                  value={formData.complaintsReceived.percentage}
                  onChange={(e) =>
                    handleNestedInputChange(
                      "complaintsReceived",
                      "percentage",
                      e.target.value
                    )
                  }
                  placeholder={"Numbers"}
                  error={!!errors["complaintsReceived.percentage"]}
                  helperText={errors["complaintsReceived.percentage"]}
                  disabled={disabled}
                />
              </Box>

              <Box sx={{ width: "85%" }}>
                <CustomTextField
                  value={formData.complaintsReceived.remark}
                  onChange={(e) =>
                    handleNestedInputChange(
                      "complaintsReceived",
                      "remark",
                      e.target.value
                    )
                  }
                  error={!!errors["complaintsReceived.remark"]}
                  helperText={errors["complaintsReceived.remark"]}
                  disabled={disabled}
                />
              </Box>
            </Box>

            <SectionHeading text="ii. Complaints from regulatory bodies." />
            <Box
              sx={{
                display: "flex",
                width: "100%",
                gap: "10px",
                alignItems: "center",
              }}
            >
              <Box sx={{ width: "15%" }}>
                <CustomTextField
                  value={formData.regulatoryBodies.percentage}
                  onChange={(e) =>
                    handleNestedInputChange(
                      "regulatoryBodies",
                      "percentage",
                      e.target.value
                    )
                  }
                  placeholder={"Numbers"}
                  error={!!errors["regulatoryBodies.percentage"]}
                  helperText={errors["regulatoryBodies.percentage"]}
                  disabled={disabled}
                />
              </Box>

              <Box sx={{ width: "85%" }}>
                <CustomTextField
                  value={formData.regulatoryBodies.remark}
                  onChange={(e) =>
                    handleNestedInputChange(
                      "regulatoryBodies",
                      "remark",
                      e.target.value
                    )
                  }
                  error={!!errors["regulatoryBodies.remark"]}
                  helperText={errors["regulatoryBodies.remark"]}
                  disabled={disabled}
                />
              </Box>
            </Box>
          </Box>

          <SectionHeading text="b. How many leaks, thefts, or losses of customer data were identified?" />
          <Box
            sx={{
              display: "flex",
              width: "100%",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <Box sx={{ width: "15%" }}>
              <CustomTextField
                value={formData.customerDataIdentified.percentage}
                onChange={(e) =>
                  handleNestedInputChange(
                    "customerDataIdentified",
                    "percentage",
                    e.target.value
                  )
                }
                placeholder={"Numbers"}
                error={!!errors["customerDataIdentified.percentage"]}
                helperText={errors["customerDataIdentified.percentage"]}
                disabled={disabled}
              />
            </Box>

            <Box sx={{ width: "85%" }}>
              <CustomTextField
                value={formData.customerDataIdentified.remark}
                onChange={(e) =>
                  handleNestedInputChange(
                    "customerDataIdentified",
                    "remark",
                    e.target.value
                  )
                }
                error={!!errors["customerDataIdentified.remark"]}
                helperText={errors["customerDataIdentified.remark"]}
                disabled={disabled}
              />
            </Box>
          </Box>

          <SectionHeading text="c. If the organization did not identify any substantiated complaints regarding breaches of customer privacy, a brief statement confirming this fact is sufficient." />

          <CustomTextField
            value={formData.noPrivacyComplaints.remark}
            onChange={(e) =>
              handleNestedInputChange(
                "noPrivacyComplaints",
                "remark",
                e.target.value
              )
            }
            error={!!errors["noPrivacyComplaints.remark"]}
            helperText={errors["noPrivacyComplaints.remark"]}
            disabled={disabled}
          />
        </Box>

        {/* Submit Button */}
       

        {/* Snackbar for success/error messages */}
        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  )

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
             {!griReview ? (
          <Box sx={{ ml: "1rem", width: "98%" }}>
            <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
          </Box>
        ) : (
          <Box textAlign="right" sx={{ mt: 3 }}>
            <Button
              variant="contained"
              sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
              onClick={handleSubmit}
            >
              Save & Continue <EastIcon sx={{ ml: 2 }} />
            </Button>
          </Box>
        )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI418;
